export enum ActivityStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}
